export default "__VITE_ASSET__0s96FBxv__"